export default "__VITE_ASSET__CyWSzCKd__"